import {IntermediatePart} from "../../intermediatePart";
import {createParentPositions} from "../../constants";
import {IS_PRODUCT_JOURNEY} from "../../../../../config";

export default class GlassHolder extends IntermediatePart {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'glass_holder';
    this.partName = 'Glass Holder';
    this.translateId = "visualizer.bathroom.shower.glass_holder";
    this.layerPriority = 13;
    if (isChild) {
      createParentPositions(this);
    }
  }

  canDisplayDemoPoint() {
    return IS_PRODUCT_JOURNEY
  }
}
